var map = {
	"./features/accounts/accounts.module": [
		"./src/app/features/accounts/accounts.module.ts",
		"common",
		"features-accounts-accounts-module"
	],
	"./features/clients/clients.module": [
		"./src/app/features/clients/clients.module.ts",
		"features-clients-clients-module"
	],
	"./features/realms/realms.module": [
		"./src/app/features/realms/realms.module.ts",
		"features-realms-realms-module"
	],
	"./features/roles/roles.module": [
		"./src/app/features/roles/roles.module.ts",
		"common",
		"features-roles-roles-module"
	],
	"./features/scopes/scopes.module": [
		"./src/app/features/scopes/scopes.module.ts",
		"common",
		"features-scopes-scopes-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;